import React from 'react';
import { styles } from './dashboardStyles';
import { ProductionRow, ProductionStats } from './types';
import { Table } from 'semantic-ui-react';

interface DashboardTableProps {
  sortedData: ProductionRow[];
  filter: string;
  setFilter: (filter: string) => void;
  stats: ProductionStats;
  rawDataLength: number;
}

export const DashboardTable: React.FC<DashboardTableProps> = ({
  sortedData,
  filter,
  setFilter,
  stats,
  rawDataLength,
}) => {
  return (
    <div
      style={{
        padding: '20px',
        width: '92%',
        margin: 'auto',
      }}
    >
      <div style={styles.sectionHeader}>
        <div>
          <h2 style={styles.sectionTitle}>Work Log</h2>
          <p style={styles.sectionSubtitle}>Detailed task tracking and time entries</p>
        </div>

        {/* Filter Buttons */}
        <div style={styles.filterBar}>
  {/* All Tasks */}
  <button
    style={{
      ...styles.filterBtn,
      ...(filter === 'all' ? styles.filterBtnActive : {}),
    }}
    onClick={() => setFilter('all')}
  >
    All Tasks <span style={styles.filterBadge}>{rawDataLength}</span>
  </button>

  {/* In Progress */}
  <button
    style={{
      ...styles.filterBtn,
      ...(filter === 'In Progress' ? styles.filterBtnActive : {}),
    }}
    onClick={() => setFilter('In Progress')}
  >
    In Progress <span style={styles.filterBadge}>{stats.inProgress || 0}</span>
  </button>

  {/* Complete */}
  <button
    style={{
      ...styles.filterBtn,
      ...(filter === 'Complete' ? styles.filterBtnActive : {}),
    }}
    onClick={() => setFilter('Complete')}
  >
    Complete <span style={styles.filterBadge}>{stats.completed || 0}</span>
  </button>

  {/* Query */}
  <button
    style={{
      ...styles.filterBtn,
      ...(filter === 'Query' ? styles.filterBtnActive : {}),
    }}
    onClick={() => setFilter('Query')}
  >
    Query <span style={styles.filterBadge}>{stats.statusCounts?.['Query'] || 0}</span>
  </button>

  {/* Combined Quality Check */}
  <button
    style={{
      ...styles.filterBtn,
      ...(filter === 'Quality Check' ? styles.filterBtnActive : {}),
    }}
    onClick={() => setFilter('Quality Check')}
  >
    Quality Check <span style={styles.filterBadge}>{stats.qualityCheck || 0}</span>
  </button>

  {/* Individual QC Stages */}
  <button
    style={{
      ...styles.filterBtn,
      ...(filter === 'QC 1' ? styles.filterBtnActive : {}),
    }}
    onClick={() => setFilter('QC 1')}
  >
    QC 1 <span style={styles.filterBadge}>{stats.qc1 || 0}</span>
  </button>

  <button
    style={{
      ...styles.filterBtn,
      ...(filter === 'QC 2' ? styles.filterBtnActive : {}),
    }}
    onClick={() => setFilter('QC 2')}
  >
    QC 2 <span style={styles.filterBadge}>{stats.qc2 || 0}</span>
  </button>

  <button
    style={{
      ...styles.filterBtn,
      ...(filter === 'QC 3' ? styles.filterBtnActive : {}),
    }}
    onClick={() => setFilter('QC 3')}
  >
    QC 3 <span style={styles.filterBadge}>{stats.qc3 || 0}</span>
  </button>
</div>
      </div>

      {/* Table */}
      <div
        style={{
          maxHeight: '890px',
          overflowY: 'auto',
          width: '100%',
          border: '1px solid #e9eaeb',
        }}
      >
        <Table celled striped style={{ fontSize: '12px' }}>
          <Table.Header style={{ position: 'sticky', top: 0, zIndex: 99, background: '#fff' }}>
            <Table.Row>
              <Table.HeaderCell>S.No</Table.HeaderCell>
              <Table.HeaderCell>Date</Table.HeaderCell>
              <Table.HeaderCell>Employee ID</Table.HeaderCell>
              <Table.HeaderCell>Employee Name</Table.HeaderCell>
              <Table.HeaderCell>Title</Table.HeaderCell>
              <Table.HeaderCell>UCC ID</Table.HeaderCell>
              <Table.HeaderCell>Batch</Table.HeaderCell>
              <Table.HeaderCell>Total Reel</Table.HeaderCell>
              <Table.HeaderCell>Total Scanned Frames</Table.HeaderCell>
              <Table.HeaderCell>Total Duration</Table.HeaderCell>
              <Table.HeaderCell>Rejection Minutes</Table.HeaderCell>
              <Table.HeaderCell>No of Corrections</Table.HeaderCell>
              <Table.HeaderCell>Types of Correction</Table.HeaderCell>
              <Table.HeaderCell>Type of Film</Table.HeaderCell>
              <Table.HeaderCell>Task</Table.HeaderCell>
              <Table.HeaderCell>Scope of Work</Table.HeaderCell>
              <Table.HeaderCell>Start Reel</Table.HeaderCell>
              <Table.HeaderCell>End Reel</Table.HeaderCell>
              <Table.HeaderCell>Comp Reel</Table.HeaderCell>
              <Table.HeaderCell>Comp Reel Frames</Table.HeaderCell>
              <Table.HeaderCell>Comp Reel Duration</Table.HeaderCell>
              <Table.HeaderCell>Start Time</Table.HeaderCell>
              <Table.HeaderCell>End Time</Table.HeaderCell>
              <Table.HeaderCell>Total Hours</Table.HeaderCell>
              <Table.HeaderCell>Productivity</Table.HeaderCell>
              <Table.HeaderCell>Status</Table.HeaderCell>
              <Table.HeaderCell>Remarks</Table.HeaderCell>
            </Table.Row>
          </Table.Header>

          <Table.Body>
            {sortedData.length === 0 ? (
              <Table.Row>
                <Table.Cell colSpan={27} textAlign="center">
                  No data available for the selected filter
                </Table.Cell>
              </Table.Row>
            ) : (
              sortedData.map((report, index) => (
                <Table.Row key={index}>
                  <Table.Cell>{index + 1}</Table.Cell>
                  <Table.Cell>{report.date}</Table.Cell>
                  <Table.Cell>{report.emp_ID}</Table.Cell>
                  <Table.Cell>{report.emp_Name}</Table.Cell>
                  <Table.Cell>{report.title}</Table.Cell>
                  <Table.Cell>{report.ucC_ID}</Table.Cell>
                  <Table.Cell>{report.batch}</Table.Cell>
                  <Table.Cell>{report.total_Reel}</Table.Cell>
                  <Table.Cell>{report.total_Scanned_Frames}</Table.Cell>
                  <Table.Cell>{report.total_Duration}</Table.Cell>
                  <Table.Cell>{report.rejection_Minutes}</Table.Cell>
                  <Table.Cell>{report.no_of_Corrections}</Table.Cell>
                  <Table.Cell>{report.types_of_Correction}</Table.Cell>
                  <Table.Cell>{report.type_of_Film_BW_Color}</Table.Cell>
                  <Table.Cell>{report.task}</Table.Cell>
                  <Table.Cell>{report.scope_of_work}</Table.Cell>
                  <Table.Cell>{report.start_Reel}</Table.Cell>
                  <Table.Cell>{report.end_Reel}</Table.Cell>
                  <Table.Cell>{report.comp_Reel}</Table.Cell>
                  <Table.Cell>{report.comp_Reel_Frames}</Table.Cell>
                  <Table.Cell>{report.comp_Reel_Frames_Duration}</Table.Cell>
                  <Table.Cell>{report.start_time}</Table.Cell>
                  <Table.Cell>{report.end_time}</Table.Cell>
                  <Table.Cell>{report.total_Hours}</Table.Cell>
                  <Table.Cell>{report.productionHours}%</Table.Cell>
                  <Table.Cell>
                    <span
                      style={{
                        padding: '4px 8px',
                        borderRadius: '4px',
                        fontSize: '11px',
                        fontWeight: 'bold',
                        backgroundColor:
                          report.status === 'Completed'
                            ? '#d4edda'
                            : report.status?.startsWith('QC')
                            ? '#fff3cd'
                            : report.status === 'In Progress'
                            ? '#d1ecf1'
                            : '#f8f9fa',
                        color:
                          report.status === 'Completed'
                            ? '#155724'
                            : report.status?.startsWith('QC')
                            ? '#856404'
                            : report.status === 'In Progress'
                            ? '#0c5460'
                            : '#495057',
                      }}
                    >
                      {report.status || 'Unknown'}
                    </span>
                  </Table.Cell>
                  <Table.Cell>{report.remarks}</Table.Cell>
                </Table.Row>
              ))
            )}
          </Table.Body>
        </Table>
      </div>
    </div>
  );
};